import {
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    input,
    output,
} from '@angular/core';

export type HeaderImage = {
    src: string;
    alt: string;
};

/**
 * Cabeçalho da aplicação, com título, logo e botão de menu.
 *
 * NOTA: o template ainda é um placeholder — os inputs abaixo definem a API
 * pretendida, mas não estão totalmente conectados ao template. Emite
 * {@link menuClick} ao acionar o menu.
 */
@Component({
    selector: 'conversai-header',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './header.component.html',
})
export class Header {
    /** Indica se o menu está aberto. */
    isMenuOpen = input<boolean>(true);
    /** Título da seção de links. */
    titleLinks = input<string>('Título dos Links');
    /** Título da seção de links com ícone. */
    titleIconLinks = input<string>('Título dos Links de Ícones');
    /** Título principal exibido no cabeçalho. */
    title = input<string>('Título');
    /** Assinatura/subtítulo. */
    signature = input<string>('Assinatura');
    /** Define se o cabeçalho é fixo (sticky). */
    isSticky = input<boolean>(true);
    /** Define se o cabeçalho exibe o botão de menu. */
    hasMenu = input<boolean>(true);
    /** Define se o título é um link. */
    hasTitleLink = input<boolean>(true);
    /** Define se o container ocupa toda a largura. */
    containerFluid = input<boolean>(true);
    /** URL do link do título. */
    titleLinkUrl = input<string>('');
    /** Imagem (logo) exibida no cabeçalho. */
    image = input<HeaderImage>({
        src: 'assets/logo_angular.png',
        alt: 'Logo de exemplo',
    });
    /** Emite o estado de abertura do menu ao clicar no botão de menu. */
    menuClick = output<boolean>();

    /** Aciona o menu, emitindo {@link menuClick} com o estado atual. */
    toggleMenu(): void {
        this.menuClick.emit(this.isMenuOpen());
    }
}
